import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import { Transform } from 'class-transformer';
import type { MediaSimpleFilterableTypeEnum } from './../constants.js';
import type { MediaSimplePreviewStatusEnum } from './../constants.js';
import type { MediaSimpleScanStatusEnum } from './../constants.js';
import type { MediaSimpleModelTypeEnum } from './../constants.js';
import { MediaSimpleVariant } from './../../overrides/model/MediaSimpleVariant.js';
import type { Constructor } from '@whispli/types';

export class __MediaSimple extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly id: string = '';
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly name!: string;
  /**
   * @deprecated For backwards-compatibility only. Use collectionName
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private collection_name!: string;

  @Expose({groups: ['client']})
  public get collectionName() {
    return this.collection_name
  }

  public set collectionName(value) {
    this.collection_name = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use filterableType
   */
  @Type(() => String)
  @Expose({groups:["server"]})
  private filterable_type?: MediaSimpleFilterableTypeEnum | null;

  @Expose({groups: ['client']})
  public get filterableType() {
    return this.filterable_type
  }

  public set filterableType(value) {
    this.filterable_type = value
  }

  @Expose({ groups: ['client', 'server'] })
  @Type(() => Object)
  public readonly uuid!: string | null;
  /**
   * @deprecated For backwards-compatibility only. Use fileName
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private file_name!: string;

  @Expose({groups: ['client']})
  public get fileName() {
    return this.file_name
  }

  public set fileName(value) {
    this.file_name = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use mimeType
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private mime_type!: string;

  @Expose({groups: ['client']})
  public get mimeType() {
    return this.mime_type
  }

  public set mimeType(value) {
    this.mime_type = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use orderColumn
   */
  @Expose({groups:["server"]})
  @Type(() => Number)
  private order_column!: number;

  @Expose({groups: ['client']})
  public get orderColumn() {
    return this.order_column
  }

  public set orderColumn(value) {
    this.order_column = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use previewUrl
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private preview_url?: string | null;

  @Expose({groups: ['client']})
  public get previewUrl() {
    return this.preview_url
  }

  public set previewUrl(value) {
    this.preview_url = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use downloadUrl
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private download_url?: string | null;

  @Expose({groups: ['client']})
  public get downloadUrl() {
    return this.download_url
  }

  public set downloadUrl(value) {
    this.download_url = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use previewStatus
   */
  @Type(() => String)
  @Expose({groups:["server"]})
  private preview_status?: MediaSimplePreviewStatusEnum | null;

  @Expose({groups: ['client']})
  public get previewStatus() {
    return this.preview_status
  }

  public set previewStatus(value) {
    this.preview_status = value
  }

  @Expose({ groups: ['client', 'server'] })
  @Type(() => Object)
  public readonly size!: number | null;
  /**
   * @deprecated For backwards-compatibility only. Use scanStatus
   */
  @Type(() => String)
  @Expose({groups:["server"]})
  private scan_status?: MediaSimpleScanStatusEnum | null;

  @Expose({groups: ['client']})
  public get scanStatus() {
    return this.scan_status
  }

  public set scanStatus(value) {
    this.scan_status = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use modelType
   */
  @Type(() => String)
  @Expose({groups:["server"]})
  private model_type!: MediaSimpleModelTypeEnum;

  @Expose({groups: ['client']})
  public get modelType() {
    return this.model_type
  }

  public set modelType(value) {
    this.model_type = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use createdByType
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private created_by_type!: string | null;

  @Expose({groups: ['client']})
  public get createdByType() {
    return this.created_by_type
  }

  public set createdByType(value) {
    this.created_by_type = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use createdById
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private created_by_id!: string | null;

  @Expose({groups: ['client']})
  public get createdById() {
    return this.created_by_id
  }

  public set createdById(value) {
    this.created_by_id = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use createdAt
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private created_at!: string;

  @Expose({groups: ['client']})
  public get createdAt() {
    return this.created_at
  }

  public set createdAt(value) {
    this.created_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use updatedAt
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private updated_at!: string;

  @Expose({groups: ['client']})
  public get updatedAt() {
    return this.updated_at
  }

  public set updatedAt(value) {
    this.updated_at = value
  }

  @Type(() => MediaSimpleVariant)
  @Expose({ groups: ['client', 'server'] })
  public readonly variants?: (MediaSimpleVariant)[];
}

interface OptionalAlias {
  filterableType?: any;
  previewUrl?: string | null | undefined;
  downloadUrl?: string | null | undefined;
  previewStatus?: any;
  scanStatus?: any;
}
export type MediaSimple = Omit<__MediaSimple, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'collection_name' | 'filterable_type' | 'file_name' | 'mime_type' | 'order_column' | 'preview_url' | 'download_url' | 'preview_status' | 'scan_status' | 'model_type' | 'created_by_type' | 'created_by_id' | 'created_at' | 'updated_at' | 'filterableType' | 'previewUrl' | 'downloadUrl' | 'previewStatus' | 'scanStatus'> & OptionalAlias
export const MediaSimple = __MediaSimple as any as Constructor<MediaSimple>
